import { useEntityClient } from '@/data/useEntityClient'
import { getGroupFilter, useFilters } from './useFilters'
import { useSorting } from './useSorting'

/**
 * This composable returns a function that can be used to list entities in a
 * project, taking into account the current filter state.
 */
export const useListEntities = () => {
  const filterStore = useFilters()
  const sortingStore = useSorting()
  const entityClient = useEntityClient()

  return ({
    end,
    projectId,
    start,
    viewId,
    workspaceId,
    parentEntityId,
  }: {
    workspaceId: string
    projectId: string
    start: number
    end: number
    parentEntityId?: string
    viewId?: string
  }) => {
    const orderBys: string[] = []
    const orderDirections: ('asc' | 'desc')[] = []

    // NOTE: Our components insert a rule where property ids is 'id' when sorting by createdAt,
    // This means that if one of the order by rules is id, then there's an extra order direction
    // in the payload. This supposedly doesn't work on the backend, but it seems it does,
    // as the results do get inverted if we exclude it.

    sortingStore.sortingRules.forEach((r) => {
      if (r.propertyId !== 'id') {
        orderBys.push(r.propertyId)
      }
      orderDirections.push(r.direction)
    })

    const filter = filterStore.currentFilter?.filters.length
      ? getGroupFilter({ filter: filterStore.currentFilter, parentEntityId, activeViewId: viewId })
      : undefined

    return entityClient.listEntities({
      workspaceId,
      projectId,
      page: { start, end },
      parentEntityId,
      viewId,
      order: { by: orderBys, direction: orderDirections },
      filter,
    })
  }
}
